(function () {
  if (!document.documentElement.classList.contains('bb-cro-page')) return;

  var fired = { 25: false, 50: false, 75: false, 100: false };

  function track(event, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'bb_cro_' + event }, detail || {}));
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, detail || {});
    }
  }

  document.querySelectorAll('a[href="#bb-contour-shop"], .bb-cro-hero__cta, .bb-shop-bridge__cta, .bb-review-strip__cta, .bb-sticky-cta__btn, #bb-sticky-atc').forEach(function (el) {
    el.addEventListener('click', function () {
      track('cta_click', { cta_location: el.className || el.tagName });
    });
  });

  window.addEventListener('scroll', function () {
    var doc = document.documentElement;
    var pct = doc.scrollHeight > doc.clientHeight
      ? Math.round(((doc.scrollTop || document.body.scrollTop) / (doc.scrollHeight - doc.clientHeight)) * 100)
      : 0;
    [25, 50, 75, 100].forEach(function (mark) {
      if (pct >= mark && !fired[mark]) {
        fired[mark] = true;
        track('scroll_depth', { depth: mark });
      }
    });
  }, { passive: true });

  var shop = document.getElementById('bb-contour-shop');
  if (shop && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) track('shop_view');
      });
    }, { threshold: 0.35 }).observe(shop);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('button[name="add"], .buy-buttons button[type="submit"]');
    if (btn) track('add_to_cart_click');
  });
})();
